<template>
    <!-- SlideShow -->
    <!-- to use this component like what shown in below: -->
    <!-- <SlideShow :imgList="list"></SlideShow> -->
    <!-- Step1: import that component -->
    <!-- Step2: add that component as our components to our element's components -->
    <!-- Step3: pass list of our images (their source link) as imgList property -->
    <!-- Example of an images list: -->
    <!-- 
        list: [ 
        'https://image.shutterstock.com/image-photo/colorful-flower-on-dark-tropical-260nw-721703848.jpg',
        'https://image.shutterstock.com/image-photo/bright-spring-view-cameo-island-260nw-1048185397.jpg',
        'https://helpx.adobe.com/content/dam/help/en/stock/how-to/visual-reverse-image-search/jcr_content/main-pars/image/visual-reverse-image-search-v2_intro.jpg'
        ]
    -->

    <div>
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" 
                    :class="{'active': index == 0}"
                    v-for="(_src, index) in imgList" :key="index"
                    :data-slide-to="index"></li>
            </ol>
            <div class="carousel-inner">
                <div 
                    :class="{'active': index == 0}"
                    class="carousel-item" v-for="(_src, index) in imgList" :key="index">
                    <!-- <img :src="_src.Cover" class="d-block w-100" alt="..." @click="showing(index)"> -->
                    <a :href="_src.Link"
                       :style="{ 'background-image': 'url(' + _src.Cover + ')' }"
                    ></a>
                </div>
            </div>
        </div>
        <!-- 
        <div id="fullDiv" v-if="show">
            <span
                class="close" 
                @click="showing"
            >&times;</span>
            <div id="_carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#_carouselExampleIndicators" 
                        :class="{'active': index == showIndex}"
                        v-for="(_src, index) in imgList" :key="index"
                        :data-slide-to="index"></li>
                </ol>
                <div class="full-carousel-inner">
                    <div 
                        :class="{'active': index == showIndex}"
                        class="full-item carousel-item" v-for="(_src, index) in imgList" :key="index">
                        <img :src="_src.Cover" class="d-block w-100" alt="...">
                    </div>
                </div>
                <a class="carousel-control-prev" href="#_carouselExampleIndicators" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#_carouselExampleIndicators" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
        </div> 
        -->
    </div>
</template>

<script>
export default {
    name: 'SlideShow',
    data() {
        return {
            show: false,
            showIndex: 0,
            height: 0
        }
    },
    props: {
        imgList: Array
    },
    methods: {
        showing(index) {
            this.showIndex = index;
            this.show = !this.show;

            if(this.show){
                document.documentElement.style.overflow = 'hidden';
                this.$root.$refs.our_footer.style.display = 'none';
                return
            }
            document.documentElement.style.overflow = 'auto';
            this.$root.$refs.our_footer.style.display = 'flex';
        }
    }
}
</script>

<style scoped>
#fullDiv .carousel-inner {
    height: 100%;
}
#fullDiv .carousel-item img {
    height: 100%;
    object-fit: contain;
}

.carousel-inner {
    height: 50vw;
    width: calc(100% - 26pt);
    margin: 0 13pt;

    border-radius: 6vh;
}
.carousel-item {
    background: rgb(85, 85, 85);
}
.carousel-item a {
    height: 50vw;
    width: 100%;
    display: inline-block;

    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.full-carousel-inner {
    height: 100vh;
}
.full-item {
    background: #000;
    height: 100%;
}
.full-item img {
    max-height: 80vh !important;
    margin: 10vh auto !important;
    max-width: 90%;
    object-fit: contain;
}
/* Indicators */
.carousel-indicators {
    padding-right: 0 !important;

    margin-bottom: 0pt;
}
.carousel-indicators li {
    height: 15pt;
    width: 15pt;

    background-color: transparent;
    opacity: 1;

    background-image: url('../assets/images/elements/green_circle.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.carousel-indicators li.active {
    background-image: url('../assets/images/elements/red_circle.png');
}

/* Modal */
#fullDiv {
    height: 100vh;
    width: 100vw;
    left: 0;
    top: 0;
    overflow: hidden;
    position: fixed;

    background: #000;
    z-index: 1030;
}
.close {
    color: #fff;
    position: absolute;
    right: 0;
    font-size: 2rem;
    margin-top: 12pt;
    margin-right: 12pt;
    z-index: 20;
}
</style>
